import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createAdminConversationForm } from '@entities/AdminConversationCategory/api/handlers/createAdminConversationForm';

export function useCreateAdminConversationFormQuery() {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: createAdminConversationForm,
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['adminConversationCategories'] });
        },
    });
}
